/*
 * Peças pequenas que várias telas da IA usam:
 * os três pontinhos que ondulam (AiIndicatorWave), o esqueleto de blocos que
 * aparecem e piscam enquanto o resumo é gerado (AiBlinkingAnimation) e os
 * detalhes do que o bot consultou ("Pesquisou por…").
 */
import Icon from 'flarum/common/components/Icon';
import Link from 'flarum/common/components/Link';
import { t } from '../../utils/settings';

/** "A IA está gerando conteúdo…" — os pontos sobem um depois do outro. */
export function indicatorWave() {
  return m("span", {
    className: "CanelaAi-wave",
    "aria-hidden": "true"
  }, m("span", {
    className: "CanelaAi-waveDot"
  }, "."), m("span", {
    className: "CanelaAi-waveDot"
  }, "."), m("span", {
    className: "CanelaAi-waveDot"
  }, "."));
}
const BLOCKS = 20;

/**
 * Os blocos cinza do esqueleto. As larguras e a ordem ficam no CSS;
 * o ritmo (um bloco a cada 250 ms, depois o piscar em sequência)
 * fica todo no CSS, pelo índice de cada bloco.
 */
export function blinkingAnimation() {
  return m("ul", {
    className: "CanelaAi-blinking",
    "aria-hidden": "true"
  }, Array.from({
    length: BLOCKS
  }, (_, index) => m("li", {
    className: "CanelaAi-blinkingItem",
    style: {
      '--i': String(index)
    }
  })));
}
/**
 * O que o bot consultou, num `<details>` fechado acima da resposta:
 * "Pesquisou por "x" — 5 resultados", que abre
 * com os links; "Leu o tópico X".
 */
export function toolDetails(activities) {
  if (!activities?.length) return null;
  return m("div", {
    className: "CanelaAi-tools"
  }, activities.map(activity => {
    if (activity.tool === 'read_topic') {
      return m("div", {
        className: "CanelaAi-details CanelaAi-details--read"
      }, m(Icon, {
        name: "fas fa-book-open"
      }), ' ', activity.topic ? m("span", null, t('ai.tools.read'), " ", m(Link, {
        href: activity.topic.url
      }, activity.topic.title)) : m("span", null, t('ai.tools.read_missing')));
    }
    const results = activity.results || [];
    return m("details", {
      className: "CanelaAi-details"
    }, m("summary", {
      className: "CanelaAi-detailsSummary"
    }, m(Icon, {
      name: "fas fa-caret-right",
      className: "CanelaAi-detailsCaret CanelaAi-detailsCaret--collapsed"
    }), m(Icon, {
      name: "fas fa-caret-down",
      className: "CanelaAi-detailsCaret CanelaAi-detailsCaret--expanded"
    }), m(Icon, {
      name: "fas fa-magnifying-glass"
    }), " ", t('ai.tools.searched', {
      query: activity.query || '',
      count: results.length
    })), results.length > 0 && m("ul", {
      className: "CanelaAi-detailsList"
    }, results.map(result => m("li", null, m(Link, {
      href: result.url
    }, result.title)))));
  }));
}
flarum.reg.add('ramon-canela', 'forum/features/ai/ui', { indicatorWave: indicatorWave,blinkingAnimation: blinkingAnimation,toolDetails: toolDetails, });